// import config
import axios from '../config/axios';

export const getBankDetils = async () => {
    try {
        const respData = await axios({
            'url': `/api/admin/getBankDetails`,
            'method': 'get'
        })
        return {
            status: "success",
            loading: false,
            result: respData.data.result
        }
    } catch (err) {
        return {
            status: 'failed',
            loading: false
        }
    }
}

export const updateBankDetails = async (data) => {
    try {
        const respData = await axios({
            'url': `/api/admin/updateBankDetails`,
            'method': 'put',
            'data': data
        })
        return {
            status: "success",
            loading: false,
            message: respData.data.message,
            result: respData.data.result
        }
    } catch (err) {
        return {
            status: 'failed',
            loading: false,
            error: err.response.data.errors
        }
    }
}